import React from 'react';
import { domToReact} from 'html-react-parser';
import {CustomOfferCard} from '@quickenloans-ui-suite/components/marketplace';
import {
    useSourceIdCookie,
} from '../../../../useContentReplacers/contentReplacers/sourceid/useSourceIdCookie';
import constructSourceId from '../../../../useContentReplacers/contentReplacers/sourceid/constructSourceId';
import { parserBlockName, sourceIdSuffix, attribNames, defaultCtaUrl, dataTest } from './Constants';
import { parserPropTypes, parserPropTypesDefaults } from '../Constants';
import { customOfferCardFoundation } from './customOfferCardFoundation.module.scss';

const toCustomOfferCard = (parserData) =>
{
    const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'local';
    const { parserOptions: {replaceFn} } = parserData;
    const Wrapper = ({
        name = parserPropTypesDefaults.name, 
        type = parserPropTypesDefaults.type, 
        attribs = parserPropTypesDefaults.attribs, 
        children = parserPropTypesDefaults.children,
    }) =>
    {
        if ( type !== 'tag' ) return null;
        if ( !name || name !== 'div' ) return null;
        if ( !attribs?.class || !attribs.class.includes(parserBlockName) ) return null;
        const fillColor = attribs[ attribNames.FILL_COLOR];

        const addedClassnames = attribs.class.split(' ').filter( 
            className => ( className !== parserBlockName && !className.includes('wp-block'))
        ).join(' ');
        const groupChild = children.find( child => child.attribs?.class.includes( attribNames.CARD_GROUP) );
        if ( !groupChild ) return null;

        const blushBlock = groupChild.children.find( child => child.attribs?.class.includes( attribNames.CARD_BLUSH ) );
        const bodyBlock = groupChild.children.find( child => child.attribs?.class.includes( attribNames.CARD_BODY ) );
        const ctaBlock = groupChild.children.find( child => child.attribs?.class.includes( attribNames.CARD_CTA ) );

        const blushImg = blushBlock.children.find( child => child.name === 'img' );
        const bodyChildren = domToReact( bodyBlock.children, replaceFn() );
        const ctaAnchor = ctaBlock.children.find( child => child.name === 'a' );

        const ctaText = ctaAnchor.children
            .find( child => child.name === 'span' )
            .children.find( child => child.type === 'text' )
            .data;

        const config = {
            imageSrc: blushImg?.attribs.src || "",
            imageAlt: blushImg?.attribs.alt || "",
            cta: {
                redirectUrl: ctaAnchor.attribs.href || defaultCtaUrl,
                ctaText,
            },
            fillColor,
        }
        const { sourceid, location } = useSourceIdCookie();
        const contentSourceId = sourceid || constructSourceId( location, sourceIdSuffix );
        return (
            <div 
                className={`${customOfferCardFoundation} ${addedClassnames}`}
                data-testid={dataTest.FOUNDATION}>
                <CustomOfferCard
                    sourceId={contentSourceId} 
                    environment={activeEnv}
                    config={config}
                >{bodyChildren}</CustomOfferCard>
            </div>
        )
    }
    Wrapper.propTypes = parserPropTypes;
    return Wrapper;
}
export default toCustomOfferCard;
